import { HostURL_API } from "../config/appSettings"

export const API_BASE_URL = HostURL_API

export const ApiURLs = {
    Auth: {
        BasicFormAuthentication: "/auth/form",
        FormAuthPasswordReset: "/auth/form/reset",
        LogoutUser: "/user/logout",
        VerifyToken: "/auth/verifyKey",
        VerifyMSALIdentity: "/auth/resolveMSALIdentity",
        AuthTokenKey: "/auth/form/authTokenKey",
        GenerateCaptcha: "/auth/generateCaptcha",
        RefreshToken: "/auth/refreshKey"
    },
    Document: {
        Upload: "/file/upload",
        SaveUploadedDocuments: "/file/upload/save",
        getDocuments: "/documents",
        editdocuments: "/editdocuments",
        deleteMultipleDocs: "/documents",
        downloadDocs: "/documents/download",
        analytics: {
            docFormat: '/documents/analytics/docformat',
            uploadedcount: '/documents/analytics/docsuploaded'
        }
    },
    Template: {
        Upload: "/template"
    },
    Config: {
        Upload: "/file/upload/config",
        Chart : "/chart/config",
        Gai : "/gai/config"
    },
    Newsfeed: {
        getNews: "/data/newsFeed",
        analytics: {
            newsUploaded: '/data/newsFeed/analytics/uploaded',
            newsType: '/data/newsFeed/analytics/type'
        }
    },
    Data: {
        Listing: "/data/listing",
        getEmail: "/data/validateEmailExistsAlready",
        masterData: "/data/master",
        versionListing: "/data/listing/version",
    },
    Resource: {
        getResource: "/data/resource",
    },
    Roles: {
        getRoles: "/data/activeRoles",
        getAssignedUserCount: "/data/assignedUserCount"
    },
    BulkUserUpload: {
        download: "/downloadBulkUploadTemplate",
        upload: "/uploadBulkDataTemplate"
    },
    Tenant: {
        getTenantList: "/tenant/tenantList",
        switchTenant: "/tenant/switch"
    }
}

